import React from 'react';
import { Role } from 'store/user/auth0.helpers';
import { useUser } from 'store/user/useUser';
import { FeatureFlag, featureFlagIsTrue } from 'utils/helpers/featureFlag.helpers';
import { userHasPermissions } from 'utils/helpers/permissions.helpers';

export interface RestrictedComponentProps {
  allowedRoles: Role[];
  featureFlag?: FeatureFlag;
  children: React.ReactNode;
}

const RestrictedComponent: React.FC<RestrictedComponentProps> = ({ allowedRoles, featureFlag, children }) => {
  const user = useUser();
  const hasPermission = userHasPermissions(user, allowedRoles);

  const canAccess = featureFlagIsTrue(featureFlag, user) && hasPermission;

  if (!canAccess) {
    return null;
  }

  return <>{children}</>;
};

export const withRestricted =
  <P extends Record<string, any>>(
    Component: React.ComponentType<P> | React.ElementType,
    allowedRoles: Role[],
    featureFlag?: FeatureFlag,
  ): React.FC<P> =>
  (props: P) => {
    const user = useUser();
    const hasPermission = userHasPermissions(user, allowedRoles);

    const canAccess = featureFlagIsTrue(featureFlag, user) && hasPermission;

    if (!canAccess) {
      return null;
    }

    return <Component {...props} />;
  };

export default RestrictedComponent;
